import { Button, ExtendableModalProps, Icon } from "@ncs/web-legos"
import { Modal } from "@ncs/web-legos"
import {
	ModalErrorActionsStyle,
	ModalErrorButtonStyle,
	ModalErrorContentContainerStyle,
	ModalErrorContentDescriptionStyle,
	ModalErrorContentStyle,
	ModalErrorContentTitleStyle,
	ModalErrorFooterCTAStyle,
	ModalErrorReasonStyle,
} from "./style"
import { useTheme } from "@material-ui/core"
import { FC } from "react"

export interface ErrorPaymentModalProps extends ExtendableModalProps {
	errorMessage: string
	onContactSupport: () => void
}

const ErrorPaymentModal: FC<ErrorPaymentModalProps> = ({
	errorMessage,
	onContactSupport,
	...rest
}) => {
	const theme = useTheme()
	return (
		<Modal
			showCloseButton={false}
			aboveFooterContent={
				<div css={{ textAlign: "center" }}>
					<button css={ModalErrorFooterCTAStyle(theme)} onClick={onContactSupport}>
						CONTACT US
					</button>
				</div>
			}
			contentStyle={ModalErrorContentStyle(theme)}
			actionsStyle={ModalErrorActionsStyle}
			{...rest}
		>
			<div css={ModalErrorContentContainerStyle}>
				<Icon icon="circle-xmark" customColor="red" />
				<p css={ModalErrorContentTitleStyle}>Oops...</p>
				<h3 css={ModalErrorReasonStyle}>Something went wrong!</h3>
				<p css={ModalErrorContentDescriptionStyle}>{errorMessage}</p>
				<Button
					variant="primary-cta"
					buttonText="OK"
					width="156px"
					css={ModalErrorButtonStyle}
					onClick={() => {
						rest?.onClose()
					}}
				/>
			</div>
		</Modal>
	)
}

export default ErrorPaymentModal
